export enum LengthUnit {
  UNIT_MM = 'mm',
  UNIT_CM = 'cm',
  UNIT_INCH = 'inch',
}
